import { DataService } from './../../../../../services/data.service';
import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../../../services/common-request-response.service';
import { NotificationService } from './../../../../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { TableHead } from '../../../../../models';




@Component({
  selector: 'app-student-sports-panel',
  templateUrl: './student-sports-panel.component.html',
  styleUrls: ['./student-sports-panel.component.scss']
})
export class StudentSportsPanelComponent implements OnDestroy, OnChanges {
  @Input() profileData: any;

  sportListJson = [];
  sportsText: any;
  firstList = [];
  secondList = [];
  thirdList = [];
  showSort = [false];
  showSortSecond = [false];
  showSortlast = [false];
  sportsJson: any;
  sportFormsTouched = false;
  tableHead: TableHead[] = [
    { title: 'Sport Name:', field: 'text', sort: false },
    { title: 'Division I:', isStatic: true},
    { title: 'Division II:', isStatic: true },
    { title: 'Division III:', isStatic: true },
    { title: 'Other:', isStatic: true }

  ];
  private destroyed$ = new Subject();


  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private commonService: CommonService,
    private dataService: DataService
  ) {
    this.getSportList();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.sportFormsTouched = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.setSportData(changes['profileData'].currentValue || {});
    }
  }

  getSportList() {
    const dataList = this.dataService.getEntity('Sports').item || [];
    this.sportListJson = dataList.map(entry => ({ checked: false, text: entry.text, id: entry.id, other: entry.other, options: { 0: false, 1: false, 2: false, 3: false }}));
  }

  sportsData(item: any) {
    this.commonDataSharedService.studentQuestionaryThreeSportsTextData.next(item);
  }

  setSportData(detailData) {
    if (detailData) {
      this.sportsJson = detailData;
      this.sportsText = this.sportsJson.otherSport;
      this.sportsData(this.sportsText);

      if (this.sportListJson && this.sportListJson.length > 0 && this.sportsJson && this.sportsJson.sportsClassIds && this.sportsJson.sportsClassIds.length > 0) {
        for (let i = 0; i < this.sportsJson.sportsClassIds.length; i++) {
          for (let j = 0; j < this.sportListJson.length; j++) {
            if (this.sportsJson.sportsClassIds[i].sportsClassId === this.sportListJson[j].id) {
              this.sportListJson[j].checked = true;
              this.sportListJson[j].options['0'] = this.sportsJson.sportsClassIds[i].item.first;
              this.sportListJson[j].options['1'] = this.sportsJson.sportsClassIds[i].item.second;
              this.sportListJson[j].options['2'] = this.sportsJson.sportsClassIds[i].item.third;
              this.sportListJson[j].options['3'] = this.sportsJson.sportsClassIds[i].item.none;
            }
          }
        }
      }
      this.sportChange();
    }
  }

  sportChange() {
    const selectedSport = [];
    for (let i = 0; i < this.sportListJson.length; i++) {
      if (this.sportListJson[i].options['0'] || this.sportListJson[i].options['1'] || this.sportListJson[i].options['2'] || this.sportListJson[i].options['3']) {
        selectedSport.push({ sportsClassId: this.sportListJson[i].id, item: { first: this.sportListJson[i].options['0'], second: this.sportListJson[i].options['1'], third: this.sportListJson[i].options['2'], none: this.sportListJson[i].options['3'] } });
      }
    }
    this.commonDataSharedService.studentQuestionaryThreeSportsFirstData.next(selectedSport);
  }

  sortTable(orderBy, columnName, order) {
    this.showSort[order] = !this.showSort[order];
    this.firstList.sort(this.commonService.dynamicSort(columnName, false));
  }

  sortTableSecond(orderBy, columnName, order) {
    this.showSortSecond[order] = !this.showSortSecond[order];
    this.secondList.sort(this.commonService.dynamicSort(columnName, false));
  }

  sortTableLast(orderBy, columnName, order) {
    this.showSortlast[order] = !this.showSortlast[order];
    this.thirdList.sort(this.commonService.dynamicSort(columnName, false));
  }

  changeValue() {
    this.sportFormsTouched = true;
  }
}
